import { render, staticRenderFns } from "./AdminApiUsage.vue?vue&type=template&id=70fbecf8"
import script from "./AdminApiUsage.vue?vue&type=script&lang=js"
export * from "./AdminApiUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports